import ResetPasswordPage from './components/ResetPasswordPage'

export default ResetPasswordPage
